import SubjectAddress from '@Domain/Subjects/SubjectAddress';

/** Reads the dossier from a queued item's context; falls back to the legacy `beneficiaryId` key. */
const readSubjectAddressFromContext = (
	context: Readonly<Record<string, string | number>>,
): SubjectAddress | null => {
	const { subjectTypeKey, subjectId, beneficiaryId } = context;

	if (typeof subjectTypeKey === 'string' && typeof subjectId === 'number') {
		return new SubjectAddress(subjectTypeKey, subjectId);
	}

	if (typeof beneficiaryId === 'number') {
		return SubjectAddress.forBeneficiary(beneficiaryId);
	}

	return null;
};

export default readSubjectAddressFromContext;
